(() => {
  if (window.__mbCartProductViewReady) return;
  window.__mbCartProductViewReady = true;

  const cache = new Map();
  const TARGET_TEXT = 'tabla de medidas';

  const parseDocument = (markup) =>
    new DOMParser().parseFromString(markup || '', 'text/html');

  const normalizeText = (value) =>
    String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase('es-AR');

  const setLoading = (button, loading) => {
    if (!button) return;
    button.classList.toggle('loading', loading);
    button.toggleAttribute('aria-busy', loading);
    button.toggleAttribute('aria-disabled', loading);
    const loader = button.querySelector('.ajax-loader');
    if (loader) loader.classList.toggle('hidden', !loading);
  };

  const reinjectScripts = (container) => {
    container.querySelectorAll('script').forEach((oldScript) => {
      const script = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attribute) => {
        script.setAttribute(attribute.name, attribute.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  };

  const findMeasureTarget = (description) => {
    if (!description) return null;

    const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, noscript')) {
          return NodeFilter.FILTER_REJECT;
        }
        return normalizeText(node.nodeValue).includes(TARGET_TEXT)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      },
    });

    const textNode = walker.nextNode();
    if (!textNode?.parentElement) return null;
    return (
      textNode.parentElement.closest('h1, h2, h3, h4, h5, h6, p, li, tr, div') ||
      textNode.parentElement
    );
  };

  const scrollInsideModal = (modal, target) => {
    const scroller = modal.querySelector('.mb-cart-product-view__dialog');
    if (!scroller || !target) return;

    const scrollerRect = scroller.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const top = scroller.scrollTop + targetRect.top - scrollerRect.top - 72;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    scroller.scrollTo({
      top: Math.max(0, top),
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  };

  const prepareProductSection = (sourceSection, modal) => {
    const productSection = sourceSection.cloneNode(true);

    productSection
      .querySelectorAll('product-modal, modal-dialog, pickup-availability')
      .forEach((element) => element.remove());

    const originalSectionId = productSection.dataset.section;
    if (originalSectionId) {
      const replacement = `cartview-${modal.id.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
      productSection.innerHTML = productSection.innerHTML
        .split(originalSectionId)
        .join(replacement);

      productSection.querySelectorAll('selects-box, pr-option, product-info').forEach((element) => {
        element.dataset.originalSection = originalSectionId;
      });
    }

    // No modal do carrinho mantemos somente os atalhos úteis para escolha da peça.
    productSection.querySelectorAll('.mb-product-shortcuts .grid-wrapper').forEach((wrapper) => {
      const keep = wrapper.querySelector(
        '[data-mb-measure-scroll], [data-bs-target="#size-modal"]'
      );
      if (!keep) wrapper.remove();
    });

    productSection.querySelectorAll('[data-mb-measure-scroll]').forEach((button) => {
      button.removeAttribute('data-mb-measure-scroll');
      button.setAttribute('data-mb-cart-measure-scroll', '');
    });

    productSection.querySelectorAll('[data-bs-target="#size-modal"]').forEach((button) => {
      button.removeAttribute('data-bs-toggle');
      button.removeAttribute('data-bs-target');
      button.setAttribute('data-mb-cart-size-guide-open', '');
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-expanded', 'false');
    });

    // O modal é uma decisão de produto; conteúdos auxiliares/upsells continuam no fluxo normal da PDP.
    productSection.querySelectorAll('.bdm-instagram, .product-complementary').forEach((element) => {
      element.closest('.product-info')?.remove() || element.remove();
    });

    return productSection;
  };

  const buildDescription = (sourceDocument) => {
    const sourceDescription = sourceDocument.querySelector(
      '.product-description-tab [data-mb-product-description], .product-description-tab .product-description'
    );
    if (!sourceDescription) return null;

    const section = document.createElement('section');
    section.className = 'mb-cart-product-view__description';
    section.setAttribute('data-mb-cart-product-description', '');
    section.innerHTML = `
      <h3 class="mb-cart-product-view__description-title">Detalles del producto</h3>
      <div class="mb-cart-product-view__description-body rte" data-mb-product-description></div>
    `;
    section.querySelector('[data-mb-product-description]').innerHTML = sourceDescription.innerHTML;
    return section;
  };

  const buildSizeGuide = (sourceDocument, modal) => {
    const sourceModal = sourceDocument.querySelector('#size-modal');
    const sourceContent = sourceModal?.querySelector('.modal-content');
    if (!sourceContent) return null;

    const guide = document.createElement('div');
    guide.className = 'mb-cart-product-view__size-guide';
    guide.setAttribute('data-mb-cart-size-guide', '');
    guide.setAttribute('hidden', '');
    guide.setAttribute('aria-hidden', 'true');

    const suffix = modal.id.replace(/[^a-zA-Z0-9_-]/g, '-');
    const titleId = `mb-cart-size-guide-title-${suffix}`;
    const panelId = `mb-cart-size-guide-panel-${suffix}`;
    guide.innerHTML = `
      <div class="mb-cart-product-view__size-guide-backdrop" data-mb-cart-size-guide-close></div>
      <div id="${panelId}" class="mb-cart-product-view__size-guide-panel size-modal" role="dialog" aria-modal="true" aria-labelledby="${titleId}" tabindex="-1">
        <div class="mb-cart-product-view__size-guide-header">
          <h3 id="${titleId}">Guía de talles</h3>
          <button type="button" class="mb-cart-product-view__size-guide-close" data-mb-cart-size-guide-close aria-label="Cerrar guía de talles">
            <i class="feather-x" aria-hidden="true"></i>
          </button>
        </div>
        <div class="mb-cart-product-view__size-guide-body" data-mb-cart-size-guide-body></div>
      </div>
    `;

    const body = guide.querySelector('[data-mb-cart-size-guide-body]');
    const clonedContent = sourceContent.cloneNode(true);
    clonedContent.querySelectorAll('.pop-close, [data-bs-dismiss="modal"]').forEach((element) => element.remove());
    while (clonedContent.firstChild) body.append(clonedContent.firstChild);
    return guide;
  };

  let activeSizeGuideOpener = null;

  const openSizeGuide = (modal, opener) => {
    const guide = modal?.querySelector('[data-mb-cart-size-guide]');
    if (!guide) return;
    activeSizeGuideOpener = opener;
    opener?.setAttribute('aria-expanded', 'true');
    guide.hidden = false;
    guide.setAttribute('aria-hidden', 'false');
    guide.classList.add('is-open');
    guide.querySelector('[role="dialog"]')?.focus({ preventScroll: true });
  };

  const closeSizeGuide = (guide) => {
    if (!guide) return;
    guide.classList.remove('is-open');
    guide.setAttribute('aria-hidden', 'true');
    guide.hidden = true;
    if (activeSizeGuideOpener) {
      activeSizeGuideOpener.setAttribute('aria-expanded', 'false');
      activeSizeGuideOpener.focus({ preventScroll: true });
    }
    activeSizeGuideOpener = null;
  };

  const loadMarkup = async (url) => {
    if (cache.has(url)) return cache.get(url);

    const promise = fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }).then(async (response) => {
      if (!response.ok) throw new Error(`Product request failed (${response.status})`);
      return response.text();
    });

    cache.set(url, promise);
    try {
      return await promise;
    } catch (error) {
      cache.delete(url);
      throw error;
    }
  };

  const openModal = async (button) => {
    const modalSelector = button.dataset.modal;
    const productUrl = button.dataset.productUrl;
    const modal = modalSelector && document.querySelector(modalSelector);
    if (!modal || !productUrl || button.hasAttribute('aria-busy')) return;

    const content = modal.querySelector('[data-mb-cart-product-view-content]');
    if (!content) return;

    setLoading(button, true);
    content.innerHTML = '<div class="mb-cart-product-view__loading" role="status">Cargando opciones…</div>';
    modal.openedBy = button;
    modal.setAttribute('open', '');
    modal.dataset.mbCartProductViewOpen = 'true';
    modal.querySelector('[role="dialog"]')?.focus({ preventScroll: true });

    try {
      const markup = await loadMarkup(productUrl);
      const sourceDocument = parseDocument(markup);
      const sourceSection = sourceDocument.querySelector('section[id^="MainProduct-"]');
      if (!sourceSection) throw new Error('Main product section not found');

      const productSection = prepareProductSection(sourceSection, modal);
      const description = buildDescription(sourceDocument);
      const sizeGuide = buildSizeGuide(sourceDocument, modal);

      modal.querySelector('[data-mb-cart-size-guide]')?.remove();
      content.innerHTML = '';
      content.append(productSection);
      if (description) content.append(description);
      if (sizeGuide) {
        modal.append(sizeGuide);
        productSection.querySelectorAll('[data-mb-cart-size-guide-open]').forEach((button) => {
          button.setAttribute('aria-controls', sizeGuide.querySelector('[role="dialog"]')?.id || '');
        });
      } else {
        productSection.querySelectorAll('[data-mb-cart-size-guide-open]').forEach((button) => {
          button.closest('.grid-wrapper')?.remove();
        });
      }

      const variantInput = content.querySelector("form [name='id']");
      if (variantInput) variantInput.disabled = false;

      reinjectScripts(content);

      const dialog = modal.querySelector('[role="dialog"]');
      if (dialog) {
        dialog.scrollTop = 0;
        dialog.focus({ preventScroll: true });
      }
    } catch (error) {
      console.error('Unable to open cart product view:', error);
      content.innerHTML = `
        <div class="mb-cart-product-view__error" role="alert">
          No se pudieron cargar las opciones del producto. Cerrá esta ventana e intentá nuevamente.
        </div>
      `;
      modal.openedBy = button;
      modal.setAttribute('open', '');
    } finally {
      setLoading(button, false);
    }
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const guide = document.querySelector('.mb-cart-product-view [data-mb-cart-size-guide]:not([hidden])');
    if (!guide) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    closeSizeGuide(guide);
  }, true);

  document.addEventListener(
    'click',
    (event) => {
      const opener = event.target.closest('[data-mb-cart-product-view]');
      if (opener) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openModal(opener);
        return;
      }

      const sizeGuideButton = event.target.closest(
        '.mb-cart-product-view [data-mb-cart-size-guide-open]'
      );
      if (sizeGuideButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openSizeGuide(sizeGuideButton.closest('.mb-cart-product-view'), sizeGuideButton);
        return;
      }

      const sizeGuideClose = event.target.closest(
        '.mb-cart-product-view [data-mb-cart-size-guide-close]'
      );
      if (sizeGuideClose) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeSizeGuide(sizeGuideClose.closest('[data-mb-cart-size-guide]'));
        return;
      }

      const measureButton = event.target.closest(
        '.mb-cart-product-view [data-mb-cart-measure-scroll]'
      );
      if (measureButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const modal = measureButton.closest('.mb-cart-product-view');
        const description = modal?.querySelector('[data-mb-cart-product-description]');
        const target = findMeasureTarget(description) || description;
        if (modal && target) scrollInsideModal(modal, target);
      }
    },
    true
  );
})();
